import * as React from 'react'

import './Preloader.scss'

interface PreloaderProps {
  hidden?: boolean
}

const Preloader: React.FC<PreloaderProps> = props => {
  return (
    <div className={`srprs-preloader ${props.hidden ? 'is-hidden' : ''}`}>
      <div className="dot" />
      <div className="shadow" />
    </div>
  )
}

Preloader.defaultProps = {
  hidden: true,
}

export default Preloader
